document.addEventListener('DOMContentLoaded', function() {
    const sidebar = document.querySelector('.custom-product-sidebar.custom-product-sidebar__products');
    const openButtons = document.querySelectorAll('[data-action="open-swatches-sidebar"]');
    const closeButtons = document.querySelectorAll('[data-action="close-swatches-sidebar"]');

    function openSidebar(btn) {
        sidebar.classList.add('is-active');
        btn.closest('.product-info__fixed-content')?.classList.add('temporary-hide');
        document.body.style.overflow = 'hidden';
    }
    function closeSidebar() {
        sidebar.classList.remove('is-active');
        document.querySelector('.temporary-hide')?.classList.remove('temporary-hide');
        document.body.style.overflow = '';
    }
    openButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
            openSidebar(btn);
        });
    });
    closeButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
            closeSidebar(btn);
        });
    });
    sidebar?.addEventListener('click', function(e) {
        if (e.target === sidebar) {
            sidebar.classList.remove('is-active');
            document.body.style.overflow = '';
        }
    });
});